import { render, staticRenderFns } from "./AboutArticleList.vue?vue&type=template&id=1d11fddf&scoped=true"
import script from "./AboutArticleList.vue?vue&type=script&lang=js"
export * from "./AboutArticleList.vue?vue&type=script&lang=js"
import style0 from "./AboutArticleList.vue?vue&type=style&index=0&id=1d11fddf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d11fddf",
  null
  
)

export default component.exports